var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDirection(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 43.8 57.47",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "_442_Direction_hotel_motel_room",
    "data-name": "442, Direction, hotel, motel, room"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-700)",
    className: "cls-1",
    d: "m34.28,57.47H4.54c-.6,0-1.21-.5-1.21-1.21,0-.61.5-1.21,1.21-1.21h29.74c.6,0,1.21.5,1.21,1.21-.1.71-.61,1.21-1.21,1.21Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-700)",
    className: "cls-1",
    d: "m15.32,29.84c-.3,0-.5-.1-.71-.2-.3-.2-.5-.6-.5-.91v-2.72c0-.3.2-.71.4-.91.2-.2.61-.3.91-.3l6.25.91,1.51-.4c.3-.1.71,0,1.01.2.3.2.5.6.5.91h0c0,.5-.3,1.01-.81,1.11l-8.17,2.32h-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-700)",
    className: "cls-1",
    d: "m23.49,57.27h-8.17c-.6,0-1.21-.5-1.21-1.21v-16.33c0-.5.3-1.01.81-1.11l8.17-2.32c.3-.1.71,0,1.01.2.3.2.5.6.5.91v18.65c.1.61-.4,1.21-1.11,1.21Zm-6.96-2.42h5.85v-15.83l-5.85,1.71v14.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-700)",
    className: "cls-1",
    d: "m15.32,8.37c-.3,0-.5-.1-.71-.3-.3-.2-.4-.5-.4-.91V1.21c0-.6.5-1.21,1.21-1.21h8.17c.6,0,1.21.5,1.21,1.21v4.44c0,.5-.4,1.01-.91,1.11l-8.17,1.61h-.4Zm1.21-6.05v3.43l5.85-1.11v-2.22l-5.85-.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-700)",
    className: "cls-1",
    d: "m23.49,17.44h-.2l-8.17-1.11c-.61-.1-1.01-.61-1.01-1.21h0c0-.3.2-.71.4-.91.2-.2.61-.3.91-.3l1.92.3,5.95-1.21c.3-.1.71,0,1.01.2.3.2.4.5.4.91v2.02c0,.3-.2.71-.4.91-.2.3-.5.4-.81.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-700)",
    className: "cls-1",
    d: "m17.44,16.54h-.2l-6.45-.91c-.5-.1-.91-.4-1.01-.91l-1.21-6.25c-.1-.3,0-.61.2-.91.2-.3.4-.4.71-.5l18.35-3.53c.3,0,.5,0,.71.1l5.95,2.92c.3.1.5.4.61.81.1.3,0,.71-.2,1.01l-4.33,5.44c-.2.2-.4.4-.71.4l-12.2,2.42c-.1-.1-.2-.1-.2-.1Zm-5.54-3.13l5.44.81,11.59-2.32,3.12-3.93-4.23-2.12-16.84,3.33.91,4.23Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-700)",
    className: "cls-1",
    d: "m10.28,42.35c-.5,0-1.01-.3-1.11-.81l-3.12-10.18c-.1-.3-.1-.6.1-.91.2-.3.4-.5.71-.61l27.42-7.86c.3-.1.5,0,.81.1l7.96,3.53c.3.1.6.4.71.81.1.4,0,.71-.2,1.01l-4.84,6.65c-.2.2-.4.4-.6.4l-27.32,7.76c-.2.1-.3.1-.5.1Zm-1.61-10.59l2.52,7.96,25.81-7.36,3.83-5.14-6.35-2.82-25.81,7.36Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-700)",
    className: "cls-1",
    d: "m21.78,28.03h-.2l-14.82-2.02c-.3,0-.5-.2-.71-.4L.3,19.06c-.2-.3-.3-.61-.3-1.01.1-.3.3-.71.6-.81l7.26-4.03c.2-.1.5-.2.71-.1l23.19,3.23c.3,0,.6.2.81.5.2.3.3.5.2.91l-1.01,6.86c-.1.5-.4.81-.81,1.01l-8.77,2.52c-.1-.2-.3-.1-.4-.1Zm-14.22-4.34l14.11,2.02,7.86-2.32.71-4.94-21.58-3.02-5.65,3.13,4.54,5.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-700)",
    className: "cls-1",
    d: "m14.11,36.2c-.5,0-1.01-.3-1.11-.91-.2-.61.2-1.31.81-1.41l17.54-4.64c.6-.2,1.31.2,1.41.81.1.6-.2,1.31-.81,1.41l-17.54,4.64q-.1.1-.3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-700)",
    className: "cls-1",
    d: "m24.7,22.18h-.2l-14.01-2.32c-.61-.1-1.11-.71-1.01-1.31.1-.6.71-1.11,1.31-1.01l14.01,2.32c.6.1,1.11.71,1.01,1.31-.1.61-.6,1.01-1.11,1.01Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-700)",
    className: "cls-1",
    d: "m14.11,12.91c-.5,0-1.01-.4-1.11-.91-.1-.6.3-1.21.91-1.41l10.49-2.42c.6-.1,1.21.3,1.41.91.2.61-.3,1.21-.91,1.41l-10.49,2.32c-.1,0-.2.1-.3.1Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDirection);
export default __webpack_public_path__ + "static/media/direction.51f0287b34ab84ffcf3a5e6aceabda34.svg";
export { ForwardRef as ReactComponent };